export const theme = {
  colors: {
    blackColor: '#1E1E23',
    whiteColor: '#FFFFFF',
    accentBlue: '#2184D1',
    mediumBlue: '#6fa9d6',
    darkGray: '#97989E',
    lightGray: '#FAFBFC',
    gray1: '#ECEFF1',
    gray: '#D4D5D8',
    titleColor: '#37474F',
    stepActiveColor: '#455A64',
    stepColor: '#607D8B',
    background: '#F4F4F499',
    link: '#4FB0DF',
    descriptionColor: '#78909C',
    green: '#1DBC49',
  },
};
